import { render, staticRenderFns } from "./MyHomeworks.vue?vue&type=template&id=0264fb78"
import script from "./MyHomeworks.vue?vue&type=script&lang=js"
export * from "./MyHomeworks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/CoreProductivity.Backoffice.Mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0264fb78')) {
      api.createRecord('0264fb78', component.options)
    } else {
      api.reload('0264fb78', component.options)
    }
    module.hot.accept("./MyHomeworks.vue?vue&type=template&id=0264fb78", function () {
      api.rerender('0264fb78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/pages/homework/MyHomeworks.vue"
export default component.exports